export interface KeyDefinition {
  legend: string;
  label: string;
  width: 'square' | 'wide' | 'widest';
}

export const KEYS = {
  command: { legend: '⌘', label: 'Command', width: 'square' },
  shift: { legend: '⇧', label: 'Shift', width: 'wide' },
  option: { legend: '⌥', label: 'Option', width: 'square' },
  control: { legend: '⌃', label: 'Control', width: 'square' },
  caps: { legend: '⇪', label: 'Caps Lock', width: 'wide' },
  fn: { legend: 'fn', label: 'Function', width: 'square' },

  escape: { legend: 'esc', label: 'Escape', width: 'wide' },
  tab: { legend: '⇥', label: 'Tab', width: 'wide' },
  return: { legend: '↩', label: 'Return', width: 'wide' },
  enter: { legend: '⌅', label: 'Enter', width: 'wide' },
  delete: { legend: '⌫', label: 'Delete', width: 'wide' },
  forwardDelete: { legend: '⌦', label: 'Forward Delete', width: 'wide' },
  space: { legend: 'Space', label: 'Space', width: 'widest' },
  k: { legend: 'K', label: 'K', width: 'square' },

  up: { legend: '↑', label: 'Up Arrow', width: 'square' },
  down: { legend: '↓', label: 'Down Arrow', width: 'square' },
  left: { legend: '←', label: 'Left Arrow', width: 'square' },
  right: { legend: '→', label: 'Right Arrow', width: 'square' },

  home: { legend: '↖', label: 'Home', width: 'square' },
  end: { legend: '↘', label: 'End', width: 'square' },
  pageUp: { legend: '⇞', label: 'Page Up', width: 'square' },
  pageDown: { legend: '⇟', label: 'Page Down', width: 'square' },
} as const satisfies Record<string, KeyDefinition>;

export type KeyName = keyof typeof KEYS;
